import styled from 'styled-components';

export const SituationDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SituationLine = styled.div`
  width: 320px;
`;
